<div [formGroup]="form" class="flexLine">

    <kal-form-field [class.without-label]="!monthLabel">

        <kal-select [label]="monthLabel"
                    [placeholder]="monthPlaceholder"
                    formControlName="month">
            <kal-option [value]="null">Aucun</kal-option>
            <kal-option *ngFor="let month of monthsList"
                        [value]="month.value">
                {{ month.label }}
            </kal-option>
        </kal-select>

    </kal-form-field>


    <kal-form-field [class.without-label]="!yearLabel">

        <kal-select [label]="yearLabel"
                    [placeholder]="yearPlaceholder"
                    formControlName="year">
            <kal-option [value]="null">Aucune</kal-option>
            <kal-option *ngFor="let year of yearsList"
                        [value]="year">
                {{ year }}
            </kal-option>
        </kal-select>

    </kal-form-field>
</div>
